<div class="row">
  <div class="col-md-12 pl-4">
      <yt-fw-default-update-buttons #defaultUpdateButtons></yt-fw-default-update-buttons>
  </div>
</div>
<yt-sist-radnih-mesta-update #baseUpdate></yt-sist-radnih-mesta-update>